module.exports = __webpack_public_path__ + "static/media/dozo.64d21563.png";